import HeaderGestaoJobs from "./Header";
import FiltersGestaoJobs from "./Filters";
import useGetListJobsGroup from "./hooks/useGetListJobsGroup";
import { useEffect, useState } from "react";
import { columns } from "./column";
import DatatableAntd from "components/datatable-antd";
import styled from "styled-components";
import DeleteModal from "./components/DeleteModal";
import CreateEditModal from "./components/CreateEditModal";
import { useGetalAllJobs } from "./hooks/useGetJobs";
import ViewJobsModal from "./components/ViewJobsModal";
import ConfirmRunJobModal from "./components/ConfirmRunJobModal";

export default function GestaoJobs() {
  const [filters, setFilters] = useState<any>({
    page: 1,
    size: 10,
    descricao: "",
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const { data, isLoading, refetch } = useGetListJobsGroup({
    page,
    size: pageSize,
    name: filters.name,
    ativo: filters.ativo,
  });

  const { refetch: refetchAllJobs } = useGetalAllJobs();

  const handleRefetchCreateEditModal = () => {
    refetch();
    refetchAllJobs();
  };

  const handleFilter = (values: any) => {
    setFilters({
      ...filters,
      name: values.name,
      page: 1,
      ativo: values.ativo,
    });
  };

  useEffect(() => {
    if (data) {
      setTotal(data?.paginate?.totalCount);
    }
  }, [data]);

  return (
    <Container>
      <HeaderGestaoJobs />
      <FiltersGestaoJobs data={data?.data} handleFilter={handleFilter} />

      <Counter>
        <b>Jobs Cadastrados</b>
        <p>{data?.data.length ?? 0} Jobs</p>
      </Counter>

      <RoundedTable
        style={{ margin: 16 }}
        columns={columns}
        loading={isLoading}
        dataSource={data?.data}
        pagination={{
          total,
          pageSize,
          current: page,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />

      <DeleteModal refetch={handleRefetchCreateEditModal} />
      <CreateEditModal refetch={handleRefetchCreateEditModal} />
      <ViewJobsModal />
      <ConfirmRunJobModal />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }
`;

const Counter = styled.div`
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  border: 1px solid #e2e8f0;
  padding: 18px;
  border-radius: 8px;

  p {
    color: #fff;
    font-weight: bold;
    background-color: #12619c;
    padding: 4px 12px;
    border-radius: 15px;
  }
`;
